import { useState } from "react";
import { api, type Meal } from "../lib/api";
import { ImageLightbox } from "./ImageLightbox";

type Props = {
  meal: Meal;
  onEdit: () => void;
  onDelete: () => void;
};

export function MealCard({ meal, onEdit, onDelete }: Props) {
  const captured = new Date(meal.capturedAt as string | number);
  const [lightbox, setLightbox] = useState(false);
  const imgSrc = api.imageUrl(meal.imageKey);
  return (
    <article className="meal-card">
      <img
        className="thumb"
        src={imgSrc}
        alt=""
        loading="lazy"
        onClick={() => setLightbox(true)}
      />
      {lightbox && <ImageLightbox src={imgSrc} onClose={() => setLightbox(false)} />}
      <div className="body">
        <header>
          <div className="when">
            {captured.toLocaleString(undefined, {
              weekday: "short",
              hour: "2-digit",
              minute: "2-digit",
              month: "short",
              day: "numeric",
            })}
            {meal.edited && <span className="badge">edited</span>}
            <span className={`confidence ${meal.confidence}`}>{meal.confidence}</span>
          </div>
          <div className="totals">
            <span>
              <strong>{meal.calories}</strong> kcal
            </span>
            <span>
              <strong>{meal.proteinG}</strong> g protein
            </span>
            {meal.calories > 0 && (
              <span className="ratio-badge">
                {Math.round((meal.proteinG / meal.calories) * 100)}g / 100 kcal
              </span>
            )}
          </div>
        </header>
        {meal.caption && <p className="caption">{meal.caption}</p>}
        <ul className="items">
          {meal.items.map((it, i) => (
            <li key={i}>
              <span>{it.name}</span>
              <span className="muted">
                {Math.round(it.portion_g)} g · {Math.round(it.calories)} kcal · {it.protein_g} g p
              </span>
            </li>
          ))}
        </ul>
        <footer>
          <button className="ghost" onClick={onEdit}>
            Edit
          </button>
          <button className="ghost danger" onClick={onDelete}>
            Delete
          </button>
        </footer>
      </div>
    </article>
  );
}
